import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  CircularProgress,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNflPlayerSearch } from "../../hooks/useNflPlayerSearch";
import { getNflDisplayName } from "../../adapters/nflPlayerAdapter";
import { colors } from "../../theme";
import {
  CompareHeadshotRing,
  CompareSlotPlaceholder,
  SELECTION_HEADSHOT_SIZE,
} from "../compare/comparePlayerVisuals";

const NflCompareSlot = ({
  index,
  playerId,
  player,
  isLoading,
  accent,
  showClear,
  onSelect,
  onClear,
}) => {
  const {
    searchQuery,
    handleSearchInputChange,
    getPlayerOptionLabel,
    isPlayerOptionEqualToValue,
    renderPlayerOption,
  } = useNflPlayerSearch();
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setInputValue(player ? getNflDisplayName(player) : "");
  }, [player]);

  return (
    <Box sx={{ flex: "1 1 180px", minWidth: 160, maxWidth: 280, position: "relative" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {playerId ? (
          <CompareHeadshotRing
            playerId={playerId}
            size={SELECTION_HEADSHOT_SIZE}
            accent={accent}
            showLoading={isLoading}
            sport="nfl"
          />
        ) : (
          <CompareSlotPlaceholder size={SELECTION_HEADSHOT_SIZE} accent={accent} />
        )}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Autocomplete
            fullWidth
            size="small"
            options={searchQuery.data || []}
            value={player || null}
            loading={searchQuery.isLoading || isLoading}
            getOptionLabel={getPlayerOptionLabel}
            isOptionEqualToValue={isPlayerOptionEqualToValue}
            onChange={(_, next) => onSelect(next)}
            inputValue={inputValue}
            onInputChange={(_, next) => {
              setInputValue(next);
              handleSearchInputChange(next);
            }}
            filterOptions={(options) => options}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={`Player ${index + 1}`}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {isLoading ? <CircularProgress color="inherit" size={16} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
            renderOption={renderPlayerOption}
            noOptionsText="No players found"
          />
        </Box>
      </Box>
      {showClear && (
        <IconButton
          size="small"
          aria-label={`Remove player ${index + 1}`}
          onClick={onClear}
          sx={{
            position: "absolute",
            top: -10,
            right: -10,
            width: 22,
            height: 22,
            bgcolor: colors.paper,
            border: `1px solid ${colors.border}`,
            "&:hover": { bgcolor: "action.hover" },
          }}
        >
          <CloseIcon sx={{ fontSize: 14 }} />
        </IconButton>
      )}
    </Box>
  );
};

export default NflCompareSlot;
